import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';
import { TrackEvent } from '../types/TrackEvent';
import { UserUpdateEvent } from '../types/UserUpdateEvent';
import { PublicTrackEvent } from '../types/PublicTrackEvent';
import { PublicUserUpdateEvent } from '../types/PublicUserUpdateEvent';

const URL_EVENTS = '/v2/track/event';
const URL_USER = '/v2/track/user';
const URL_PUBLIC = '/v2/public/track-event';
const URL_PUBLIC_USER = '/v2/public/track-user';

class TrackEventService {
  static trackEvent(
    data: TrackEvent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<TrackEvent>> {
    return axios.post(URL_EVENTS, data, config);
  }

  static trackUserEvent(
    data: UserUpdateEvent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<UserUpdateEvent>> {
    return axios.post(URL_USER, data, config);
  }

  static trackPublicEvent(
    data: PublicTrackEvent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PublicTrackEvent>> {
    return axios.post(URL_PUBLIC, data, config);
  }

  static trackPublicUser(
    data: PublicUserUpdateEvent,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PublicUserUpdateEvent>> {
    return axios.post(URL_PUBLIC_USER, data, config);
  }
}

export { TrackEventService };
